import request from "../utils/request";

export async function createTarget(newTarget) {
  return request.post("Target/Create", newTarget);
}

export async function deleteTarget(id) {
  return request.delete('Target/Delete?targetId=' + id);
}

export async function getTargetList(payload) {
  const getObjId = (val) => (val != null ? (typeof val === 'object' ? val.id : val) : null);
  return request.get("Target/List", {
    params: {
      productId: getObjId(payload.product),
      branchId: getObjId(payload.branch),
      personalId: getObjId(payload.personal),
      month: getObjId(payload.month),
      year: payload.year,
      kind: kindEngConverter(payload.kind),
      type: typeEngConverter(payload.type)
    }
  });
}

export async function getTargetListForDealer(payload) {
  const getObjId = (val) => (val != null ? (typeof val === 'object' ? val.id : val) : null);
  return request.get("Target/ListForDealer", {
    params: {
      productId: getObjId(payload.product),
      branchId: getObjId(payload.branch),
      personalId: getObjId(payload.personal),
      month: getObjId(payload.month),
      year: payload.year,
      kind: kindEngConverter(payload.kind),
      type: typeEngConverter(payload.type)
    }
  });
}

export async function getTargetDetails(targetId = 0, personalUserId = null, productId = null, branchId = null, month = null, year = null) {
  return request.get("Target/Details", {
    params: {
      targetId: targetId || 0,
      personalUserId: personalUserId,
      productId: productId,
      branchId: branchId,
      month: month,
      year: year
    }
  });
}

function kindEngConverter(kind) {
  if (kind == null || typeof kind == "undefined") return null;
  if(kind == "Product" || kind == "Giro") return kind;
  let result = null;
  switch (kind) {
    case "Ürün":
      result = "Product";
      break;
    case "Ciro":
      result = "Giro";
      break;
    default:
      result = null;
      break;
  }
  return result;
}

function typeEngConverter(type) {
    if (type == null || typeof type == "undefined") return null;
    if(type == "Personal" || type == "Branch") return type;
    let result = null;
    switch (type) {
      case "Personel":
        result = "Personal";
        break;
      case "Şube":
        result = "Branch";
        break;
      default:
        result = null;
        break;
    }
    return result;
  }
